// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"53184200","678":"4955fd33","963":"5954bf68"}[chunkId] + ".chunk.js";
};